// 这个存放和业务相关的工具函数，可以引入vuex，也可以发起请求
import user from "@/store/modules/user";
import uploadImageHandler from "./editor";

export function formDownload(url, param) {
  let kyes = Object.keys(param);
  let paramArr = kyes.map(item => {
    return {
      name: item,
      value: param[item] || "" // 剔除null  undefined 等无效字段
    };
  });
  paramArr.push({
    name: "userAuthToken",
    value: user.state.token
  });
  console.log(paramArr);
  var form = document.createElement("form");
  document.getElementsByTagName("body")[0].appendChild(form);
  form.setAttribute("style", "display:none");
  form.setAttribute("target", "_blank");
  form.setAttribute("method", "post");
  form.setAttribute("action", url);
  paramArr.forEach(item => {
    var input1 = document.createElement("input");
    input1.setAttribute("type", "hidden");
    input1.setAttribute("name", item.name);
    input1.setAttribute("value", item.value);
    form.appendChild(input1);
  });
  form.submit();
  form.remove();
}

export function editorUploadHandler(options) {
  new uploadImageHandler(options);
}
